import { useNavigate } from "react-router-dom";
import "./Header.css";

const Header = ({ pageBehaviour, onClickHeaderTab }: any) => {
	const navigate = useNavigate();
	return (
		<div className="home-header-box">
			<p
				className={`home-header-nav-title ${
					pageBehaviour === "HOME" && "home-header-selected"
				}`}
				onClick={() => {
					// setPageBehaviour("HOME");
					onClickHeaderTab("HOME");
					navigate("/");
				}}
			>
				home
			</p>
			<p
				className={`home-header-nav-title ${
					pageBehaviour === "WORK" && "home-header-selected"
				}`}
				onClick={() => {
					// setPageBehaviour("WORK");
					onClickHeaderTab("WORK");
					navigate("/games");
				}}
			>
				games
			</p>
			<p
				className={`home-header-nav-title ${
					pageBehaviour === "CONTACT" &&
					"home-header-selected"
				}`}
				onClick={() => {
					// setPageBehaviour("CONTACT");
					onClickHeaderTab("CONTACT");
					navigate("/privacy-policy");
				}}
			>
				privacy policy
			</p>
		</div>
	);
};

export default Header;
